// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("expand.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("closeButton.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("helpButton.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("undoButton.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("redoButton.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rich-text-editor-hidden {
  display: none;
}

.render-error {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  font-family: sans-serif;
  font-size: 16px;
  padding: 5px 10px;
  color: red;
  pointer-events: none;
}

.rich-text-editor img[src*='/math.svg'] {
  vertical-align: middle;
  margin: 4px;
  padding: 3px 10px;
  cursor: pointer;
  border: 1px solid transparent;
}

.rich-text-editor img[src\$='/math.svg?latex='],
.rich-text-editor img[src=''] {
  display: none;
}

.rich-text-editor:focus img[src*='/math.svg'],
.rich-text-editor.rich-text-focused img[src*='/math.svg'] {
  background: #edf9ff;
  border: 1px solid #e6f2f8;
}

.rich-text-editor img[src^='/screenshot'] {
  margin: 4px;
}

.rich-text-editor:focus img[src^='/screenshot'],
.rich-text-editor.rich-text-focused img[src^='/screenshot'] {
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
}

.rich-text-editor .mq-math-mode .mq-root-block {
  white-space: nowrap;
}

.rich-text-editor:focus,
.rich-text-editor.rich-text-focused,
.rich-text-editor .mq-editable-field.mq-focused,
.rich-text-editor textarea:focus {
  box-shadow: none;
  outline: 1px solid #359bb7;
  z-index: 2;
}

.rich-text-editor img {
  max-width: 100%;
  max-height: 1000px;
}

.rich-text-editor {
}

.math-editor {
  z-index: 1;
  margin: 10px 5px 0;
  position: relative;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  display: flex;
}

.math-editor textarea {
  height: auto;
  box-shadow: none;
  border-radius: 0;
  resize: none;
  border: none;
}

.math-editor-equation-field {
  width: 50%;
  padding: 5px 10px;
  border: none;
  background: #fff;
}

.math-editor-latex-field {
  font-size: 15px;
  width: 50%;
  padding: 5px 10px;
  letter-spacing: 1px;
}

.rich-text-editor-button {
  text-align: center;
  display: inline-block;
  position: relative;
  cursor: pointer;
  border: none;
  padding: 0;
}

.math-editor-focus .rich-text-editor-button[data-command]:hover:after,
.rich-text-editor-button-action[data-command]:hover:after {
  background: #359bb7;
  border-radius: 5px;
  color: #fff;
  content: attr(data-command);
  letter-spacing: 1.5px;
  font-size: 16px;
  left: 50%;
  top: 100%;
  padding: 7px 15px;
  position: absolute;
  z-index: 32;
  transform: translate(-50%, 0);
  white-space: nowrap;
}

.math-editor-focus .rich-text-editor-button[data-command]:hover:before,
.rich-text-editor-button-action[data-command]:hover:before {
  display: inline-block;
  border: solid;
  border-color: #359bb7 transparent;
  border-width: 0 6px 6px 6px;
  bottom: 0;
  content: '';
  left: 50%;
  position: absolute;
  z-index: 99;
  margin-left: -6px;
}

.rich-text-editor-button[data-command]:after:hover,
.rich-text-editor-button[data-command]:before:hover {
  display: none;
}

.rich-text-editor-button:active {
  box-shadow: none;
}

.rich-text-editor-button-action {
  padding: 5px 10px;
  font-weight: normal;
  background: none;
  border: none;
  font-family: SourceSansPro-Semibold, sans-serif;
  font-size: 16px;
  letter-spacing: 1.5px;
  color: #359bb7;
  letter-spacing: 0;
  line-height: 22px;
}

.rich-text-editor-new-equation {
  display: block;
  vertical-align: top;
  height: 35px;
  width: 153px;
  white-space: nowrap;
}

.math-editor-focus .rich-text-editor-new-equation {
  display: none;
}

.rich-text-editor-tools {
  visibility: hidden;
  z-index: 2;
  border-bottom: 1px solid #dfdfdf;
  border-top: 1px solid #dfdfdf;
  position: fixed;
  top: -110px;
  left: 0;
  right: 0;
  box-shadow: 0 1px 10px 1px rgba(0, 0, 0, 0.2);
  line-height: 0;
  background: white;
  transition: top 0.15s;
}

.rich-text-editor-focus .rich-text-editor-show-all-characters {
  top: 0;
}

.rich-text-editor-tools--animating {
  visibility: visible;
}

.rich-text-editor-focus .rich-text-editor-tools {
  visibility: visible;
  top: 0;
}

.rich-text-editor-toolbar-wrapper {
  margin: auto;
  max-width: 990px;
  position: relative;
}

.rich-text-editor-tools-row:nth-child(even) {
  background: #fff;
}

.rich-text-editor-tools-row:nth-child(odd) {
  background: #fafafa;
  border-top: 1px solid #dfdfdf;
}

.rich-text-editor-toolbar {
  z-index: 30;
  display: inline-block;
}

.rich-text-editor-toolbar .rich-text-editor-button {
  font-size: 16px;
  background: none;
  position: relative;
}

.rich-text-editor-toolbar .rich-text-editor-button:hover {
  background: #eee;
}

.rich-text-editor-button-grid {
  width: 35px;
  height: 35px;
}

.rich-text-editor-toolbar.rich-text-editor-toolbar-button-list img {
  max-width: 24px;
  max-height: 25px;
}

.rich-text-editor-toolbar-button-list.rich-text-editor-button:hover {
  background: #ececec;
}

.rich-text-editor-toolbar-characters {
  margin-right: 30px;
}

.rich-text-editor-toolbar-characters.rich-text-editor-toolbar-button-list .rich-text-editor-button {
  font-family: Symbola, monospace;
  color: #555;
}

.rich-text-editor-toolbar-equation {
  display: none;
}

.rich-text-editor-toolbar-equation .rich-text-editor-button:last-child {
  margin-right: 35px;
}

.math-editor-focus .rich-text-editor-toolbar-equation {
  display: inline-block;
}

.rich-text-editor-toolbar-characters-group {
  margin-right: 12px;
  display: inline-block;
  vertical-align: top;
}

.rich-text-editor-toolbar-characters .rich-text-editor-button {
  display: none;
}

.rich-text-editor-show-all-characters .rich-text-editor-toolbar-characters .rich-text-editor-button,
.rich-text-editor-toolbar-characters .rich-text-editor-button.rich-text-editor-characters-popular {
  display: inline-block;
}

.rich-text-editor-characters-expand-collapse {
  display: inline-block;
  font-family: 'SansSerif', serif;
  height: 35px;
  border: none;
  cursor: pointer;
  padding-top: 4px;
  position: absolute;
  right: 35px;
  top: 0;
  bottom: 0;
  width: 20px;
  margin-right: 8px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 50% 50% no-repeat;
}

.rich-text-editor-show-all-characters .rich-text-editor-characters-expand-collapse {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.rich-text-editor-overlay-open {
  overflow-y: hidden;
}

.rich-text-editor-overlay {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 101;
}

.rich-text-editor-overlay-modal {
  position: relative;
  margin: auto;
  max-width: 860px;
  min-height: 40%;
  background: #fff;
  padding: 2rem;
  line-height: 1.5rem;
  outline: none;
}

.rich-text-editor-close-overlay-button {
  position: absolute;
  width: 25px;
  height: 25px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 50% 50%;
  border: 0;
}

.rich-text-editor-close-overlay-button:hover {
  opacity: 0.5;
}

.rich-text-editor-hidden {
  display: none;
}

.rich-text-editor-help-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 35px;
  height: 35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat 50% 50%;
  border: none;
  cursor: pointer;
  display: block;
}

.rich-text-editor-undo-redo-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  display: inline-flex;
}

.rich-text-editor-toolbar .rich-text-editor-undo-redo,
.rich-text-editor-toolbar .rich-text-editor-undo-redo:hover {
  width: 35px;
  height: 35px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border: none;
  cursor: pointer;
}

.rich-text-editor-toolbar .rich-text-editor-undo-button,
.rich-text-editor-toolbar .rich-text-editor-undo-button:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  margin-right: 5px;
}

.rich-text-editor-toolbar .rich-text-editor-redo-button,
.rich-text-editor-toolbar .rich-text-editor-redo-button:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.rich-text-editor-undo-redo:disabled {
  filter: grayscale(100%);
  pointer-events: none;
}

.rich-text-editor-modal-columns {
  display: flex;
}

.rich-text-editor-modal-column {
  margin: 0 1rem;
}

.rich-text-editor-modal-column-1 {
  flex: 1;
  white-space: nowrap;
}

.rich-text-editor-modal-column-2 {
  flex: 2;
}

.rich-text-editor-modal-column h3 {
  font-size: 18px;
  font-weight: bold;
  margin-top: 0;
}

.rich-text-editor-help-shortcuts {
  width: 100%;
  border-spacing: 0 4px;
}

.rich-text-editor-help-shortcuts th {
  text-align: left;
  font-weight: normal;
}

.rich-text-editor-help-shortcuts td {
  text-align: right;
}

.rich-text-editor-help-key {
  background: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  line-height: 1.3;
  font-family: monospace;
  display: inline-block;
  padding: 0 4px;
  margin: 0 4px;
  color: #000;
  text-align: center;
  min-width: 15px;
  text-transform: uppercase;
  vertical-align: text-top;
}

.rich-text-editor-help-shortcuts td .rich-text-editor-help-button {
  width: 100%;
  padding: 1px;
}

@media (min-width: 1279px) {
  .rich-text-editor-new-equation {
    left: -153px;
    position: absolute;
  }

  .rich-text-editor-tools-button-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .rich-text-editor-tools {
    top: -60px;
  }
}
@media print {
  .rich-text-editor-focus .rich-text-editor-tools {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/rich-text-editor/dist/rich-text-editor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,iCAAiC;EACjC,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,OAAO;EACP,QAAQ;EACR,6CAA6C;EAC7C,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,qEAA+C;AACjD;;AAEA;EACE,yDAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;EACX,eAAe;EACf,qEAAoD;EACpD,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qEAAmD;EACnD,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,yDAAuC;EACvC,iBAAiB;AACnB;;AAEA;;EAEE,yDAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".rich-text-editor-hidden {\n  display: none;\n}\n\n.render-error {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  font-family: sans-serif;\n  font-size: 16px;\n  padding: 5px 10px;\n  color: red;\n  pointer-events: none;\n}\n\n.rich-text-editor img[src*='/math.svg'] {\n  vertical-align: middle;\n  margin: 4px;\n  padding: 3px 10px;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.rich-text-editor img[src$='/math.svg?latex='],\n.rich-text-editor img[src=''] {\n  display: none;\n}\n\n.rich-text-editor:focus img[src*='/math.svg'],\n.rich-text-editor.rich-text-focused img[src*='/math.svg'] {\n  background: #edf9ff;\n  border: 1px solid #e6f2f8;\n}\n\n.rich-text-editor img[src^='/screenshot'] {\n  margin: 4px;\n}\n\n.rich-text-editor:focus img[src^='/screenshot'],\n.rich-text-editor.rich-text-focused img[src^='/screenshot'] {\n  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n}\n\n.rich-text-editor .mq-math-mode .mq-root-block {\n  white-space: nowrap;\n}\n\n.rich-text-editor:focus,\n.rich-text-editor.rich-text-focused,\n.rich-text-editor .mq-editable-field.mq-focused,\n.rich-text-editor textarea:focus {\n  box-shadow: none;\n  outline: 1px solid #359bb7;\n  z-index: 2;\n}\n\n.rich-text-editor img {\n  max-width: 100%;\n  max-height: 1000px;\n}\n\n.rich-text-editor {\n}\n\n.math-editor {\n  z-index: 1;\n  margin: 10px 5px 0;\n  position: relative;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n  display: flex;\n}\n\n.math-editor textarea {\n  height: auto;\n  box-shadow: none;\n  border-radius: 0;\n  resize: none;\n  border: none;\n}\n\n.math-editor-equation-field {\n  width: 50%;\n  padding: 5px 10px;\n  border: none;\n  background: #fff;\n}\n\n.math-editor-latex-field {\n  font-size: 15px;\n  width: 50%;\n  padding: 5px 10px;\n  letter-spacing: 1px;\n}\n\n.rich-text-editor-button {\n  text-align: center;\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n}\n\n.math-editor-focus .rich-text-editor-button[data-command]:hover:after,\n.rich-text-editor-button-action[data-command]:hover:after {\n  background: #359bb7;\n  border-radius: 5px;\n  color: #fff;\n  content: attr(data-command);\n  letter-spacing: 1.5px;\n  font-size: 16px;\n  left: 50%;\n  top: 100%;\n  padding: 7px 15px;\n  position: absolute;\n  z-index: 32;\n  transform: translate(-50%, 0);\n  white-space: nowrap;\n}\n\n.math-editor-focus .rich-text-editor-button[data-command]:hover:before,\n.rich-text-editor-button-action[data-command]:hover:before {\n  display: inline-block;\n  border: solid;\n  border-color: #359bb7 transparent;\n  border-width: 0 6px 6px 6px;\n  bottom: 0;\n  content: '';\n  left: 50%;\n  position: absolute;\n  z-index: 99;\n  margin-left: -6px;\n}\n\n.rich-text-editor-button[data-command]:after:hover,\n.rich-text-editor-button[data-command]:before:hover {\n  display: none;\n}\n\n.rich-text-editor-button:active {\n  box-shadow: none;\n}\n\n.rich-text-editor-button-action {\n  padding: 5px 10px;\n  font-weight: normal;\n  background: none;\n  border: none;\n  font-family: SourceSansPro-Semibold, sans-serif;\n  font-size: 16px;\n  letter-spacing: 1.5px;\n  color: #359bb7;\n  letter-spacing: 0;\n  line-height: 22px;\n}\n\n.rich-text-editor-new-equation {\n  display: block;\n  vertical-align: top;\n  height: 35px;\n  width: 153px;\n  white-space: nowrap;\n}\n\n.math-editor-focus .rich-text-editor-new-equation {\n  display: none;\n}\n\n.rich-text-editor-tools {\n  visibility: hidden;\n  z-index: 2;\n  border-bottom: 1px solid #dfdfdf;\n  border-top: 1px solid #dfdfdf;\n  position: fixed;\n  top: -110px;\n  left: 0;\n  right: 0;\n  box-shadow: 0 1px 10px 1px rgba(0, 0, 0, 0.2);\n  line-height: 0;\n  background: white;\n  transition: top 0.15s;\n}\n\n.rich-text-editor-focus .rich-text-editor-show-all-characters {\n  top: 0;\n}\n\n.rich-text-editor-tools--animating {\n  visibility: visible;\n}\n\n.rich-text-editor-focus .rich-text-editor-tools {\n  visibility: visible;\n  top: 0;\n}\n\n.rich-text-editor-toolbar-wrapper {\n  margin: auto;\n  max-width: 990px;\n  position: relative;\n}\n\n.rich-text-editor-tools-row:nth-child(even) {\n  background: #fff;\n}\n\n.rich-text-editor-tools-row:nth-child(odd) {\n  background: #fafafa;\n  border-top: 1px solid #dfdfdf;\n}\n\n.rich-text-editor-toolbar {\n  z-index: 30;\n  display: inline-block;\n}\n\n.rich-text-editor-toolbar .rich-text-editor-button {\n  font-size: 16px;\n  background: none;\n  position: relative;\n}\n\n.rich-text-editor-toolbar .rich-text-editor-button:hover {\n  background: #eee;\n}\n\n.rich-text-editor-button-grid {\n  width: 35px;\n  height: 35px;\n}\n\n.rich-text-editor-toolbar.rich-text-editor-toolbar-button-list img {\n  max-width: 24px;\n  max-height: 25px;\n}\n\n.rich-text-editor-toolbar-button-list.rich-text-editor-button:hover {\n  background: #ececec;\n}\n\n.rich-text-editor-toolbar-characters {\n  margin-right: 30px;\n}\n\n.rich-text-editor-toolbar-characters.rich-text-editor-toolbar-button-list .rich-text-editor-button {\n  font-family: Symbola, monospace;\n  color: #555;\n}\n\n.rich-text-editor-toolbar-equation {\n  display: none;\n}\n\n.rich-text-editor-toolbar-equation .rich-text-editor-button:last-child {\n  margin-right: 35px;\n}\n\n.math-editor-focus .rich-text-editor-toolbar-equation {\n  display: inline-block;\n}\n\n.rich-text-editor-toolbar-characters-group {\n  margin-right: 12px;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.rich-text-editor-toolbar-characters .rich-text-editor-button {\n  display: none;\n}\n\n.rich-text-editor-show-all-characters .rich-text-editor-toolbar-characters .rich-text-editor-button,\n.rich-text-editor-toolbar-characters .rich-text-editor-button.rich-text-editor-characters-popular {\n  display: inline-block;\n}\n\n.rich-text-editor-characters-expand-collapse {\n  display: inline-block;\n  font-family: 'SansSerif', serif;\n  height: 35px;\n  border: none;\n  cursor: pointer;\n  padding-top: 4px;\n  position: absolute;\n  right: 35px;\n  top: 0;\n  bottom: 0;\n  width: 20px;\n  margin-right: 8px;\n  background: url('expand.svg') 50% 50% no-repeat;\n}\n\n.rich-text-editor-show-all-characters .rich-text-editor-characters-expand-collapse {\n  background-image: url('collapse.svg');\n}\n\n.rich-text-editor-overlay-open {\n  overflow-y: hidden;\n}\n\n.rich-text-editor-overlay {\n  display: flex;\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 101;\n}\n\n.rich-text-editor-overlay-modal {\n  position: relative;\n  margin: auto;\n  max-width: 860px;\n  min-height: 40%;\n  background: #fff;\n  padding: 2rem;\n  line-height: 1.5rem;\n  outline: none;\n}\n\n.rich-text-editor-close-overlay-button {\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  top: 20px;\n  right: 20px;\n  cursor: pointer;\n  background: url('closeButton.svg') no-repeat 50% 50%;\n  border: 0;\n}\n\n.rich-text-editor-close-overlay-button:hover {\n  opacity: 0.5;\n}\n\n.rich-text-editor-hidden {\n  display: none;\n}\n\n.rich-text-editor-help-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 35px;\n  height: 35px;\n  background: url('helpButton.svg') no-repeat 50% 50%;\n  border: none;\n  cursor: pointer;\n  display: block;\n}\n\n.rich-text-editor-undo-redo-wrapper {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  display: inline-flex;\n}\n\n.rich-text-editor-toolbar .rich-text-editor-undo-redo,\n.rich-text-editor-toolbar .rich-text-editor-undo-redo:hover {\n  width: 35px;\n  height: 35px;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  border: none;\n  cursor: pointer;\n}\n\n.rich-text-editor-toolbar .rich-text-editor-undo-button,\n.rich-text-editor-toolbar .rich-text-editor-undo-button:hover {\n  background-image: url('undoButton.svg');\n  margin-right: 5px;\n}\n\n.rich-text-editor-toolbar .rich-text-editor-redo-button,\n.rich-text-editor-toolbar .rich-text-editor-redo-button:hover {\n  background-image: url('redoButton.svg');\n}\n\n.rich-text-editor-undo-redo:disabled {\n  filter: grayscale(100%);\n  pointer-events: none;\n}\n\n.rich-text-editor-modal-columns {\n  display: flex;\n}\n\n.rich-text-editor-modal-column {\n  margin: 0 1rem;\n}\n\n.rich-text-editor-modal-column-1 {\n  flex: 1;\n  white-space: nowrap;\n}\n\n.rich-text-editor-modal-column-2 {\n  flex: 2;\n}\n\n.rich-text-editor-modal-column h3 {\n  font-size: 18px;\n  font-weight: bold;\n  margin-top: 0;\n}\n\n.rich-text-editor-help-shortcuts {\n  width: 100%;\n  border-spacing: 0 4px;\n}\n\n.rich-text-editor-help-shortcuts th {\n  text-align: left;\n  font-weight: normal;\n}\n\n.rich-text-editor-help-shortcuts td {\n  text-align: right;\n}\n\n.rich-text-editor-help-key {\n  background: #fff;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  line-height: 1.3;\n  font-family: monospace;\n  display: inline-block;\n  padding: 0 4px;\n  margin: 0 4px;\n  color: #000;\n  text-align: center;\n  min-width: 15px;\n  text-transform: uppercase;\n  vertical-align: text-top;\n}\n\n.rich-text-editor-help-shortcuts td .rich-text-editor-help-button {\n  width: 100%;\n  padding: 1px;\n}\n\n@media (min-width: 1279px) {\n  .rich-text-editor-new-equation {\n    left: -153px;\n    position: absolute;\n  }\n\n  .rich-text-editor-tools-button-wrapper {\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  .rich-text-editor-tools {\n    top: -60px;\n  }\n}\n@media print {\n  .rich-text-editor-focus .rich-text-editor-tools {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
